import QuizGradingLayout from 'components/QuizGrading/QuizGradingLayout';

const Desktop = (props) => <QuizGradingLayout device={'desktop'} {...props} />;
export default Desktop;
